/**
 * Router.js por módulo 
 * 
 * @author Daniel Lepe
 * @version 1.0
 * @date 14/03/2024
 */
 
const rootPath = '/Cocinaeasylunch',
    rootName = 'Oferta',
    indexUri = 'index',
    mainComponent = () => import('./CocinaeasylunchQuicktable.vue');

const router = {
    path: rootPath,
    redirect: rootPath + '/' + indexUri,
    component: () => import('@/containers/DefaultContainer'),
    meta: {},
    children: [
        {
            path: indexUri,
            name: rootName,
            component: mainComponent
        }
    ]
}

// EASYLUNCH
const nav = {
    name: rootName,
    url: rootPath,
    icon: 'fa fa-cog'
}

export {
    rootPath, rootName,
    router,
    nav,
    mainComponent
}